import React, { Fragment, useState } from "react";

// import SideBar from "./SideBar";
import SideBar from "./SideBarLIMS";
import NavHader from "./NavHader";
import Header from "./Header";
import ChatBoxLIMS from "../../pages/LIMSpages/Chat/ChatBoxLIMS";
//import RightSideBar from "./RightSideBar";
// import ChatBox from "../ChatBox";

const JobieNav = ({ title, onClick: ClickToAddEvent, onClick2, onClick3 }) => {
  const [toggle, setToggle] = useState("");
  const onClick = (name) => setToggle(toggle === name ? "" : name);
  return (
    <Fragment>
      <NavHader />
      {/* <ChatBox onClick={() => onClick("chatbox")} toggle={toggle} /> */}
      <ChatBoxLIMS onClick={() => onClick("chatbox")} toggle={toggle} />
      <Header
        onNote={() => onClick("chatbox")}
        onNotification={() => onClick("notification")}
        onProfile={() => onClick("profile")}
        toggle={toggle}
        title={title}
        onBox={() => onClick("box")}
        onClick={() => ClickToAddEvent()}
      />
      <SideBar />
    </Fragment>
  );
};

export default JobieNav;
